<template>
    <div class="main">
        <div id="mapContainer">
            <div id="myPageTop" class="lable-input">
                <table>
                    <tr>
                        <td>
                            <label>地点查询：</label>
                            <input class="s-input" id="tipinput"/>
                            <!-- <span class="l-back" @click="onBack">{{ position.length ? '确定' : '返回' }}</span> -->
                        </td>
                    </tr>
                </table>
            </div>
            <div class="back">
              <div class="back-item" @click="onBack(1)">返回</div>
              <div class="back-line"></div>
              <div class="back-item" @click="onBack(2)">确定</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    // 地点定位
    name: 'AppMap',
    props: {
        lnglat: {
            type: Array,
            default: () => [],
            required: false
        },
        searchVal: {
            type: String,
            default: '',
            required: false
        },
        address: {
            type: String,
            default: '',
            required: false
        }
    },
    data() {
        return {
            map: null,
            locationAddress: '',
            citycode: '',
            activeName: 0,
            mouseTool: '',
            position: [],
            district: null,
            polygons: [],
            lnglats: [],
            fullAddress: '',
            setType: 0
        }
    },
    methods: {
        // 地图初始化
        initMap (id, position) {
            this.map = new AMap.Map(id, {
                zoom: 16,
                center: position, // 中心点坐标
                resizeEnable: true
            })
            this.showCityInfo()
            this.drawMarker()
            this.inputSearh()
            this.showCityInfoCenter()


        },
        // 根据IP查询当前城市
        showCityInfo () {
            let citysearch = new AMap.CitySearch()
            this.citysearch = citysearch
            this.citysearch.getLocalCity(this.sendIp)
        },
        showCityInfoCenter() {
            const center = new AMap.Geolocation({
                enableHighAccuracy: false, // 高精度开启
                timeout: 10000, // 超时时间，默认：无穷大
            })
            this.map.addControl(center)
            AMap.event.addListener(center, 'complete', this.onComplete);
            center.getCurrentPosition((status, result) => {
                let icon = '../../../../map/img/jxtMarker.png'
                setTimeout(() => {
                  if(!this.lnglat) {
                    this.position = [result.position.lng, result.position.lat]
                  }
                  if(!this.fullAddress) {
                    this.fullAddress = result.formattedAddress
                  }
                  this.jxtMarkcar(icon, [result.position.lng, result.position.lat])
                }, 1000);
            })

        },
        onComplete(data) {
          console.log(data)
          console.log('定位成功信息：', data.addressComponent.city);
        },
        sendIp (status, result) {
            if (status === 'complete' && result.info === 'OK') {
                this.city = result.city.replace("市","")
                let citybounds = result.bounds
                if(this.setType) {
                    this.map.setBounds(citybounds)
                }
            }
            this.logMapinfo()
        },
        // 地图获取当前行政区信息
        logMapinfo() {
          this.map.getCity(this.getInfo)
        },
        // 具体行政区信息
        getInfo(e) {
          this.citycode = e.citycode
        },
        // 地点查询
        serchLocation() {
            AMap.service(["AMap.PlaceSearch"],() => {
                //构造地点查询类
                let placeSearch = new AMap.PlaceSearch({
                    pageSize: 1000, // 单页显示结果条数
                    pageIndex: 1, // 页码
                    city: this.citycode, // 兴趣点城市
                    citylimit: true,  //是否强制限制在设置的城市内搜索
                    map: this.map, // 展现结果的地图实例
                    // panel: "panel", // 结果列表将在此容器中进行展示。
                    autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
                })
                //关键字查询
                placeSearch.search(this.locationAddress);
            })
        },
        search_fn() {
            //构造地点查询类
            this.map.clearMap()
            let placeSearch = new AMap.PlaceSearch({
                pageSize: 1000, // 单页显示结果条数
                pageIndex: 1, // 页码
                city: this.citycode, // 兴趣点城市
                citylimit: true,  //是否强制限制在设置的城市内搜索
                map: this.map, // 展现结果的地图实例
                // panel: "panel", // 结果列表将在此容器中进行展示。
                autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
            })
            //关键字查询
            placeSearch.search(this.locationAddress);
        },

        // 标注点
        drawMarker () {
            let mouseTool = new AMap.MouseTool(this.map)
            this.mouseTool = mouseTool
            this.mouseTool.marker({
                icon: '../../../../map/img/jxtMarker.png'
            })
            this.mouseTool.on('draw', this.obtain_lng_lat)
        },
        obtain_lng_lat (e) {
            this.map.clearMap()
            // let position = e.obj.Ce.position
            let position = e.obj.De.position
            this.position = [position.lng, position.lat]
            this.getPositionByLonLats(position.lng, position.lat)
        },
        // 根据经纬度查询信息
        getPositionByLonLats(lng, lat) {
            // console.log("经度："+lng+"纬度"+lat);
            let lnglatXY = [lng, lat];// 地图上所标点的坐标
            this.lnglatXY = lnglatXY
            AMap.service('AMap.Geocoder', this.getResult)// 回调函数
            let icon = '../../../../map/img/jxtMarker.png'
            this.jxtMarkcar(icon, lnglatXY)
            // this.$emit('getMapInfo', { position: this.position})
        },
        // 获取信息
        getResult () {
            let geocoder = new AMap.Geocoder({
                radius: 1000,
                extensions: "all"
            })
            geocoder.getAddress(new AMap.LngLat(this.lnglatXY[0], this.lnglatXY[1]), this.getformattedAddress)
        },
        getformattedAddress (status, result) {
            if (status === 'complete' && result.info === 'OK') {
                var address = result.regeocode.formattedAddress
                this.fullAddress = address
            }
        },
        jxtMarkcar(icon, position) {
            let marker = new AMap.Marker({
                icon: icon,
                position: position,
                offset: new AMap.Pixel(0, 0),
                autoRotation: true,
                label: {
                  content: this.fullAddress,  //文本
                  color: '#000000',  //文本颜色
                  borderRadius: 3,  //边框圆角
                  borderWidth: 1,  //边框宽度
                  borderColor: '#ffffff',  //边框颜色
                  bgColor: '#ffffff',  //背景色
                  padding: 4,  //文本边缘留白
                  textAlign: 'center',  //文本对齐方式。有效值: left, right, center
                  anchorY: -58,
                  fontSize: 10,
                  anchorX: this.fullAddress.length > 4 ?  -22 - 2 * this.fullAddress.length - 2 : -22,
              },
            })
            this.map.add([marker])
            this.map.setCenter(position)
        },
        // 行政区划查询
        drawBounds(val) {
            this.map.clearMap()
            var that = this;
            //加载行政区划插件
            if (!that.district) {
                //实例化DistrictSearch
                var opts = {
                    subdistrict: 0, //获取边界不需要返回下级行政区
                    extensions: "all", //返回行政区边界坐标组等具体信息
                    level: "district", //查询行政级别为 x县  区
                };
                that.district = new AMap.DistrictSearch(opts);
            }
            //行政区查询
            let code = val + "";
            that.district.search(code, function (status, result) {
                that.polygons = [];
                // console.log(result)
                let bounds
                if('OK' == result.info) {
                    bounds = result.districtList[0].boundaries
                }
                if (bounds) {
                    for (var i = 0, l = bounds.length; i < l; i++) {
                        //生成行政区划polygon
                        var polygon = new AMap.Polygon({
                            strokeWeight: 1,
                            path: bounds[i],
                            fillOpacity: 0.4,
                            fillColor: "#80d8ff",
                            strokeColor: "#0091ea",
                        });
                        that.polygons.push(polygon);
                    }
                }
                that.map.add(that.polygons)
                that.map.setFitView(that.polygons); //视口自适应
                that.map.setZoom(10)
            });
        },
        inputSearh() {
            let autoOptions = {
              input: "tipinput"
            }
            let auto = new AMap.Autocomplete(autoOptions)
            let placeSearch = new AMap.PlaceSearch({
              map: this.map
            })
            AMap.event.addListener(auto, "select", function(e) {
                placeSearch.setCity(e.poi.adcode);
                placeSearch.search(e.poi.name);  //关键字查询查询
            })
        },
        geoCode(address) {
            var geocoder = new AMap.Geocoder({
                city: "",
            });

            geocoder.getLocation(address, this.setCode);
        },
        setCode(status, result) {
            let icon = '../../../../map/img/jxtMarker.png'
            if (status === 'complete' && result.geocodes.length) {
                  this.jxtMarkcar(icon, result.geocodes[0].location)
                } else {
                console.log('根据地址查询位置失败');
            }
        },
        onBack(type) {
          if(1 == type) {
            this.$emit('getMapInfo', { position:  [], fullAddress:  '' })
          } else {
            if(!this.position || !this.fullAddress) {
              this.$toast('请选择位置')
              return
            }
            this.$emit('getMapInfo', { position: this.position ? this.position : [], fullAddress: this.fullAddress ? this.fullAddress : '' })
          }

        }

    },
    mounted(){
        if(!this.lnglat.length) {
            this.setType = 1
            this.initMap('mapContainer', [116.395577, 39.892257])
            return
        }
        this.lnglats = this.lnglat
        this.fullAddress = this.address

        const arr = this.lnglats.split(',')
        this.position = arr
        if(arr.length != 0) {
            this.setType = 0
            this.initMap('mapContainer', [Number(arr[0]), Number(arr[1])])
            let icon = '../../../../map/img/jxtMarker.png'
            this.jxtMarkcar(icon, [Number(arr[0]), Number(arr[1])])
        } else {
            this.setType = 0
            let icon = '../../../../map/img/jxtMarker.png'
            this.jxtMarkcar(icon, [116.395577, 39.892257])
            this.initMap('mapContainer', [116.395577, 39.892257])
        }
    },
    watch: {
        lnglat: {
            handler: function(a, b) {
                this.lnglats = a
                this.map.setCenter(a)
                let icon = '../../../../map/img/jxtMarker.png'
                this.jxtMarkcar(icon, a)
            },
            deep: true
        },
        searchVal: {
            handler :function (n, o) {
                this.drawBounds(n)
            }
        },
        address: {
            handler: function(n, o) {
                this.geoCode(n)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    @import url('https://cache.amap.com/lbs/static/main1119.css');
    #mapContainer {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1001;
    }
    .serch-input {
        width: 100%;
        text-align: center;
        display: flex;
        margin-top: 16px;
    }
    .serch-btn {
        margin-left: 8px;
        height: 28px;
        padding: 0 20px;
        line-height: 28px;
        background: #0D67B7;
        color: #fff;
        border-radius: 0;
        cursor: pointer;
    }
    .main {
      position: relative;
    }
    .main ::v-deep.el-collapse-item__header {
        height: 18px;
        border-bottom: 0px;
    }
    .main ::v-deep.el-collapse-item__wrap {
        border-bottom: 0px;
    }
    .lable-input {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 99;
        padding: 8px !important;
        border: none !important;
        margin: 0 !important;
        border-radius: 8px;
    }
    .s-input {
        width: 180px !important;
    }

    .l-back {
        color: #3e8ef7;
        font-size: 12px;
    }
    .back {
      position: absolute;
      right: 16px;
      bottom: 32px;
      width: 100px;
      height: 32px;
      border-radius: 8px;
      z-index: 100;
      background: #ffffff;
      display: flex;
      justify-content: space-between;
      padding: 0 16px;
      &-item {
        font-size: 12px;
        color: #3e8ef7;
        line-height: 32px;
      }
      &-line {
        width: 1px;
        height: 32px;
        background: #e5e5e5;
      }

    }
</style>
